import { CloudCommand } from "../types.js";

export const getRealPostURL: CloudCommand = {
    action: "LINKEDIN_UTILS/GET_REAL_POST_URL",
    commandName: "linkedinPost.getRealPostURL",
    buildPayload: ({ url }) => ({ url }),
};
